import getUserInfo from '@/common/utils/getUserInfo'
import { handleImgSize } from '@/common/utils/map_view_data'
const getCharLen = (content) => {
    const double_chars = content.match(/[^\x00-\xff]/g)
    const double_char_len = double_chars ? double_chars.length * 2 : 0
    const single_chars = content.match(/[\x00-\xff]/g)
    const single_char_len = single_chars ? single_chars.length : 0
    return double_char_len + single_char_len
}
export default {
    data () {
        return {
            show_all: false,
            max_length: 93
        }
    },
    computed: {
        show_operate () {
            const matched_enter = this.item.content.match(/[\r\n]/g)
            return getCharLen(this.item.content) > this.max_length || (matched_enter && matched_enter.length > 2)
        }
    },
    methods: {
        showContent () {
            this.show_all = true
        },
        toggleShow () {
            this.show_all = !this.show_all
        },
        previewImg (e) {
            const { index } = e.currentTarget.dataset
            const { photos_urls } = this.item
            const urls = photos_urls.map((item) => {
                return handleImgSize(item, 1125, 2400) + '/quality,Q_80'
            })
            this.$wx.previewImage({
                current: photos_urls[index],
                urls
            })
        }
    }
}